/**
 * Reading a cookie the funnel does not own.
 *
 * Everything imt.fi wants to tell the funnel about a visitor — their consent
 * answer, their chosen home city — arrives as a `domain=.imt.fi` cookie,
 * because `localStorage` is per-origin and the funnel sits on the sibling
 * `varaus.imt.fi`. Those readers all did the same `document.cookie` walk, and
 * the walk has two traps worth having in one place: `document.cookie` can
 * throw outright where storage is blocked, and the stored value is
 * percent-encoded.
 */

/** The named cookie's decoded value, or null when there is none — or when it
 *  cannot be read or decoded. A caller must treat null as "no answer", never
 *  as a default. */
export function readCookie(name: string): string | null {
  let raw: string | undefined;
  try {
    raw = document.cookie
      .split(';')
      .map((part) => part.trim())
      .find((part) => part.startsWith(`${name}=`))
      ?.slice(name.length + 1);
  } catch {
    // `document.cookie` can throw where storage is blocked entirely.
    return null;
  }
  if (!raw) return null;

  try {
    return decodeURIComponent(raw);
  } catch {
    return null;
  }
}
